module.exports = __webpack_public_path__ + "img/48ne.fdc673e9.svg";